export default __webpack_public_path__ + "static/15-1badd798656349b1b99603585b40d51e.jpg";